<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ path: '/dashboard/clienttasks' }">Procesos</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar Constitución de Sociedad</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="selected('go')">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop id="confirmar-facturacion-modal" ref="confirmar-facturacion-modal" centered hide-footer>
      <h4 class="text-center">¿Desea facturar su pago?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="confirmGenerarFactura(false)">No en este momento</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="confirmGenerarFactura(true)">Sí</b-button>
    </b-modal>

    <b-modal
      no-close-on-backdrop
      id="datos-fiscales-modal"
      ref="datos-fiscales-modal"
      size="lg"
      centered
      hide-footer
      hide-header
      @close.prevent
    >
      <FacturacionComponent
        :datosFacturacion="datosFacturacion"
        @closedFacturacionEvent="closedFacturacion($event)"
        @canceledFacturacionEvent="canceledFacturacion()"
      />
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="pago-modal" title="" hide-footer id="modalC" size="xl">
      <p id="titulo">Forma de pago</p>
      <b-tabs fill>
        <b-tab title="Tarjeta de crédito o débito" active>
          <Openpay
            :cotizacion_id="constitutiva.cotizaciones_id"
            :precio_total="parseInt(constitutiva.precio_total)"
            @submit.prevent
            @payCotizacion="payCotizacion"
          />
        </b-tab>
        <b-tab title="SPEI/Transferencia">
          <Spei
            :cotizacion_id="constitutiva.cotizaciones_id"
            :precio_total="constitutiva.precio_total"
            :proceso_id="constitutiva.id"
            :cat_servicios_id="1"
            :tipo="'constitutiva'"
            @submit.prevent
            @payCotizacionSpei="payCotizacionSpei"
          />
        </b-tab>
        <b-tab title="Monedero">
          <Monedero
            :cotizacion_id="constitutiva.cotizaciones_id"
            :precio_total="constitutiva.precio_total"
            :clientes_id="constitutiva.clientes_id"
            :servicio="'Constitución de Sociedades ' + constitutiva.id"
            @submit.prevent
            @payCotizacion="payCotizacion"
          />
        </b-tab>
      </b-tabs>
    </b-modal>

    <b-modal no-close-on-backdrop id="modal-help-constitutiva-3" size="xl" centered hide-footer>
      <div>
        <b-carousel id="carousel-constitutiva-1" :interval="0" controls indicators background="#ababab">
          <div v-if="currentComponentBody === 'DatosGenerales'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/1_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/1_2.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/1_3.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'DatosCapital'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/2_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/2_2.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'DatosOrganos'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/3_1.webp')"></b-carousel-slide>
            <b-carousel-slide img-blank-color="ffffff">
              <template #img>
                <div class="d-flex justify-content-center align-items-center h-100" style="background-color: white">
                  <video width="80%" height="auto" controls controlsList="nodownload" poster="/img/cp_logooficial_fondoNEGRO.png">
                    <source :src="urlVideoHelp1" type="video/webm" />
                    Your browser does not support HTML5 video.
                  </video>
                </div>
              </template>
            </b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'RepresentantesYApoderados'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/4_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/4_2.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'EntidadFederativa'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/7_1.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'ComplementaInformacion'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/6_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/6_2.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/6_3.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/6_4.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/6_5.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'Accionistas'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/9_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/9_2.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/9_3.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'OrganosCorporativos'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/10_1.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'Apoderados'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/4_3.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/4_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/4_2.webp')"></b-carousel-slide>
          </div>
          <div v-if="currentComponentBody === 'BeneficiarioControlador'">
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/11_1.webp')"></b-carousel-slide>
            <b-carousel-slide :img-src="require('@/assets/img/constitutiva/help/11_2.webp')"></b-carousel-slide>
          </div>
        </b-carousel>
      </div>
    </b-modal>

    <div class="container-fluid" v-if="!toShowExpediente">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeM :constitutiva="constitutiva" :selected-component="currentComponentBody" user="Client" @node="selected" />
          </b-card>
          <div>
            <b-img
              v-if="currentComponentBody === 'DatosGenerales'"
              :src="require('@/assets/img/constitutiva/help/1.webp')"
              fluid-grow
              alt="Descripción de los datos generales"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'DatosGenerales'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'DatosCapital'"
              :src="require('@/assets/img/constitutiva/help/2.webp')"
              fluid-grow
              alt="Descripción de los datos del capital"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'DatosCapital'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'DatosOrganos'"
              :src="require('@/assets/img/constitutiva/help/3.webp')"
              fluid-grow
              alt="Descripción de los órganos corporativos"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'DatosOrganos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'RepresentantesYApoderados'"
              :src="require('@/assets/img/constitutiva/help/4.webp')"
              fluid-grow
              alt="Descripción de los representantes y apoderados"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'RepresentantesYApoderados'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'CapitulosEspeciales'"
              :src="require('@/assets/img/constitutiva/help/5.webp')"
              fluid-grow
              alt="Descripción de los capítulos especiales"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'EntidadFederativa'"
              :src="require('@/assets/img/constitutiva/help/7.webp')"
              fluid-grow
              alt="Descripción del domicilio social"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'EntidadFederativa'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'Cotizacion'"
              :src="require('@/assets/img/constitutiva/help/8.webp')"
              fluid-grow
              alt="Descripción del domicilio social"
            ></b-img>
            <b-img
              v-if="currentComponentBody === 'ComplementaInformacion'"
              :src="require('@/assets/img/constitutiva/help/6.webp')"
              fluid-grow
              alt="Descripción de la información a completar"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'ComplementaInformacion'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'Accionistas'"
              :src="require('@/assets/img/constitutiva/help/9.webp')"
              fluid-grow
              alt="Descripción de la información a completar de los accionistas"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'Accionistas'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'OrganosCorporativos'"
              :src="require('@/assets/img/constitutiva/help/10.webp')"
              fluid-grow
              alt="Descripción de la información a completar de los órganos corporativos"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'OrganosCorporativos'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'Apoderados'"
              :src="require('@/assets/img/constitutiva/help/4.webp')"
              fluid-grow
              alt="Descripción de la información a completar de los apoderados"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'Apoderados'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
            <b-img
              v-if="currentComponentBody === 'BeneficiarioControlador'"
              :src="require('@/assets/img/constitutiva/help/11.webp')"
              fluid-grow
              alt="Descripción de la información a completar del beneficiario controlador"
            ></b-img>
            <b-button
              v-if="currentComponentBody === 'BeneficiarioControlador'"
              class="orange-btn"
              block
              @click="$bvModal.show('modal-help-constitutiva-3')"
            >
              Más información
            </b-button>
          </div>
        </b-col>
        <b-col class="col-9">
          <card>
            <b-row>
              <component v-bind:is="currentComponentInfoHead" class="tab"></component>
            </b-row>
            <b-row>
              <b-col class="col-12">
                <div v-if="currentComponentBody === 'DatosGenerales'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <DatosGenerales :constitutiva="constitutiva" :optionsObjetoSocial="optionsObjetoSocial" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'DatosCapital'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <DatosCapital :constitutiva="constitutiva" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'DatosOrganos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <DatosOrganos :constitutiva="constitutiva" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'RepresentantesYApoderados'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <RepresentantesYApoderados :constitutiva="constitutiva" :cat_facultades="cat_facultades" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EntidadFederativa'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <EntidadFederativa :constitutiva="constitutiva" :catCorredurias="catCorredurias" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'CapitulosEspeciales'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <CapitulosEspeciales :constitutiva="constitutiva" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Cotizacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(pagar)">
                      <Cotizacion :constitutiva="constitutiva" :cat_gastos="cat_gastos" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <!-- <div v-if="currentComponentBody === 'ComplementaInformacion'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <ComplementaInformacion
                        :constitutiva="constitutiva"
                        @submit.prevent
                        @node="selected"
                        :cat_facultades="cat_facultades"
                      />
                    </form>
                  </ValidationObserver>
                </div> -->
                <div v-if="currentComponentBody === 'Accionistas'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <Accionistas :constitutiva="constitutiva" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'OrganosCorporativos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <OrganosCorporativos :constitutiva="constitutiva" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Apoderados'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <Apoderados :constitutiva="constitutiva" :cat_facultades="cat_facultades" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'BeneficiarioControlador'">
                  <div v-if="currentInnerComponentBody === 'BeneficiarioControlador'">
                    <ValidationObserver v-slot="{ handleSubmit }">
                      <form @submit.prevent="handleSubmit(saveConstitucion)">
                        <BeneficiarioControlador
                          :constitutiva="constitutiva"
                          @editBeneficiarioControlador="editBeneficiarioHandler"
                          @continuarEvent="saveConstitucion"
                        />
                      </form>
                    </ValidationObserver>
                  </div>
                  <div v-else-if="currentInnerComponentBody === 'DeclaracionesBeneficiarioControlador'">
                    <DeclaracionesBeneficiario
                      :accionista="currentAccionistaBeneficiario"
                      @changeInnerComponent="changeInnerComponentHandler"
                    />
                  </div>
                </div>
                <div v-if="currentComponentBody === 'EsperaValidacion'">
                  <EsperaValidacion />
                </div>
                <div v-if="currentComponentBody === 'DerechosRpc'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <DerechosRpc
                        :constitutiva="constitutiva"
                        @submit.prevent
                        @saveConstitucion="saveConstitucion"
                        @validaForm="validar"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'FirmaDigital'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <FirmaDigital
                        :constitutiva="constitutiva"
                        @node="selected"
                        :cat_facultades="cat_facultades"
                        @submit.prevent
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EntregaDocumentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <EntregaDocumentos :constitutiva="constitutiva" @submit.prevent @node="selected" />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'CitaFirma'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(saveConstitucion)">
                      <CitaFirma
                        :constitutiva="constitutiva"
                        :user="'Client'"
                        @submit.prevent
                        @node="selected"
                        @saveConstitucion="saveConstitucion"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'DocListo'">
                  <!-- <ValidationObserver v-slot="{ handleSubmit }">
                  <form @submit.prevent="handleSubmit(saveConstitucion)"> -->
                  <DocListo :constitutiva="constitutiva" @submit.prevent @node="selected" />
                  <!-- </form>
                </ValidationObserver> -->
                </div>
              </b-col>
            </b-row>
          </card>
        </b-col>
      </b-row>
    </div>
    <div class="container-fluid" v-else>
      <b-card>
        <Expediente :constitutiva="constitutiva" />
      </b-card>
    </div>
  </div>
</template>

<script>
import TreeM from "@/views/clients/procesos/constitucion/TreeM.vue";
import CitaFirma from "@/views/clients/procesos/constitucion/citafirma/CitaFirma.vue";
import ComplementaInformacion from "@/views/clients/procesos/constitucion/complementainformacion/ComplementaInformacion.vue";
import Accionistas from "@/views/clients/procesos/constitucion/Accionistas.vue";
import OrganosCorporativos from "@/views/clients/procesos/constitucion/OrganosCorporativos.vue";
import Apoderados from "@/views/clients/procesos/constitucion/Apoderados.vue";
import BeneficiarioControlador from "@/views/clients/procesos/constitucion/BeneficiarioControlador.vue";
import DerechosRpc from "@/views/clients/procesos/constitucion/DerechosRpc.vue";
import DeclaracionesBeneficiario from "@/views/clients/procesos/constitucion/DeclaracionesDuenoBeneficiario.vue";
import Cotizacion from "@/views/clients/procesos/constitucion/cotizacion/Cotizacion.vue";
import DocListo from "@/views/clients/procesos/constitucion/doclisto/DocListo.vue";
import EntregaDocumentos from "@/views/clients/procesos/constitucion/entregadocumentos/EntregaDocumentos.vue";
import FirmaDigital from "@/views/clients/procesos/constitucion/firmadigital/FirmaDigital.vue";
import CapitulosEspeciales from "@/views/clients/procesos/constitucion/infoBase/CapitulosEspeciales.vue";
import DatosCapital from "@/views/clients/procesos/constitucion/infoBase/DatosCapital.vue";
import DatosGenerales from "@/views/clients/procesos/constitucion/infoBase/DatosGenerales.vue";
import DatosOrganos from "@/views/clients/procesos/constitucion/infoBase/DatosOrganos.vue";
import EntidadFederativa from "@/views/clients/procesos/constitucion/infoBase/EntidadFederativa.vue";
import InfoBase from "@/views/clients/procesos/constitucion/infoBase/InfoBase.vue";
import RepresentantesYApoderados from "@/views/clients/procesos/constitucion/infoBase/RepresentantesYApoderados.vue";
import FacturacionComponent from "@/views/openpay/FacturacionComponent.vue";
import Monedero from "@/views/openpay/Monedero.vue";
import Openpay from "@/views/openpay/Openpay.vue";
import Spei from "@/views/openpay/Spei.vue";
import Expediente from "@/views/clients/procesos/constitucion/Expediente.vue";
import EsperaValidacion from "@/components/EsperaValidacion.vue";

import {
  CatDocumentosApi,
  CatFacultadesApi,
  CatFormulariosConstitucionSociedadesApi,
  CatGastosApi,
  CatObjetosSocialesApi,
  ConstitucionSociedadesApi,
  CotizacionesApi,
  FuncionesApi,
  FacturasApi,
} from "@/api";

import config from "@/config";
import { tryParseInt } from "@/utils/number-utils";

export default {
  name: "ConstitucionSociedades",

  components: {
    TreeM,
    InfoBase,
    DatosGenerales,
    DatosCapital,
    DatosOrganos,
    RepresentantesYApoderados,
    EntidadFederativa,
    CapitulosEspeciales,
    Cotizacion,
    EntregaDocumentos,
    CitaFirma,
    DocListo,
    ComplementaInformacion,
    Openpay,
    Spei,
    Monedero,
    FirmaDigital,
    FacturacionComponent,
    Expediente,
    Accionistas,
    OrganosCorporativos,
    Apoderados,
    BeneficiarioControlador,
    DeclaracionesBeneficiario,
    DerechosRpc,
    EsperaValidacion,
  },

  created() {
    this.loading = true;

    const id = tryParseInt(this.$route.params.id);

    if (!id) {
      this.$toast.error("El servicio solicitado no existe, será redirigido a la pantalla de inicio.", {
        timeout: 5000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });

      this.idNotParsed = true;
      this.$router.push({ name: "Dashboard" });
      this.loading = true;
      return;
    }

    this.constitutiva.id = id;

    this.getCatDocumentosPF()
      .then(() => this.getCatDocumentosPM())
      .then(() => this.getCatObjetosSociales())
      .then(() => this.getConstitucion())
      .then(async () => {
        const successfulPayment = this.$route.query.payment_status === "successful";

        if (successfulPayment && this.constitutiva.cotizaciones_id) {
          const result = await CotizacionesApi.verificarCotizacionPagada(this.constitutiva.cotizaciones_id);

          if (result.pagado) {
            this.currentComponentBody = "Cotizacion";
            this.saveConstitucion();
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.$toast.error("Sucedió un error al cargar la información.", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
      })
      .finally(() => (this.loading = false));
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == "EditComparecientes" || this.idNotParsed) {
      next();
      return;
    }

    this.next = next;
    this.$refs["modal-confirm-dialog-route"].show();
  },

  data: () => ({
    nodos: [
      "DatosGenerales",
      "DatosCapital",
      "DatosOrganos",
      "RepresentantesYApoderados",
      "CapitulosEspeciales",
      "EntidadFederativa",
      "Cotizacion",
      // "ComplementaInformacion",
      "Accionistas",
      "OrganosCorporativos",
      "Apoderados",
      "BeneficiarioControlador",
      "DerechosRpc",
      "CitaFirma",
      "FirmaDigital",
      // "EntregaDocumentos",
      // "DocListo"
    ],

    loading: false,
    next: null,
    prenode: null,

    idNotParsed: false,
    currentComponentInfoHead: "InfoBase",
    currentComponentBody: "DatosGenerales",
    currentInnerComponentBody: "BeneficiarioControlador",
    currentAccionistaBeneficiario: null,
    toShowExpediente: false,

    cat_facultades: [],
    cat_gastos: [],
    optionsObjetoSocial: [],
    optionsFisicas: [],
    optionsMorales: [],
    catCorredurias: [],

    originalConstitutiva: {},
    constitutiva: {
      estatus: null,
      estatus_id: null,
      cambios: [],

      disabled: false,
      disabledComplementa: false,
      disabledDocumentos: false,
      disabledCita: false,

      validoGenerales: false,
      validoCapital: false,
      validoOrganos: false,
      validoRepresentantes: false,
      validoCapitulos: false,
      validoEntidad: false,
      validoCotizacion: false,
      validoComplementa: false,
      validoAccionistas: false,
      validoOrganosCorporativos: false,
      validoApoderados: false,
      validoBeneficiarioControlador: false,
      validoDerechosRpc: false,
      validoEntrega: false, //ahorita no hay entrega de documentos
      validoDocListo: false,
      validoCita: false,

      accion: "edit",

      id: null,
      clientes_id: null,
      tipo_societario: null,
      denominaciones_sociales_1: null,
      denominaciones_sociales_2: null,
      denominaciones_sociales_3: null,
      denominaciones_sociales: [],
      tiene_capital_variable: true,
      autoriza_cd_denominacion: null,
      objeto_social: null,
      objeto_social_otro: null,
      objeto_actividad: null,

      capital_fijo: null,
      capital_variable: null,
      accionistas: [],
      capital_extranjero: null,

      tipo_administracion: null,
      administradores: [],
      presidente_voto: null,
      vigilancia: [],

      apoderados: [],

      link_calendario: null,
      // corredores: [],
      corredurias_id: null,
      firma_oficina: true,
      selectedEntidad: null,
      selectedMunicipio: null,
      selectedCorreduria: null,
      optionsEntidades: [],
      optionsMunicipios: [],
      optionsColonias: [],

      reglas_control: null,
      reglas_asambleas: null,

      titulos_acciones: null,
      libros_corporativos: null,
      cotizaciones_id: null,

      cupones_id: null,
      cupones_referencia_id: null,
      precio_total: 0, //para guardarlo, convierte a float
      pagado: null,
      folio_transaccion: null,
      gastos: [],
      subtotal_titulos: 0,
      subtotal_libros: 0,

      documentos: [],
      formularios: [],
      cotizacion: {},

      direccion_firma: null, //estos dos es hasta despues del pago y de haber firmado los docs firtuales fad
      fecha_firma: null,
      clausula_extranjeros: null,

      acciones_valor_nominal: null,
      exclusion_accionistas: null,

      domicilios: [],
      pais: null,
      entidadDomicilio: null,
      municipioDomicilio: null,

      beneficiario_pld: null,
      beneficiario_cff: null,
      folio: null,
      nombre_beneficiario_pld: null,
      nombre_beneficiario_cff: null,
      referencia: null,
      id_cotizaciones_complementario: null,
      cotizacion_complementaria: null,
    },

    facturarPago: false,
    datosFacturacion: {
      cotizacionId: 0,
      alreadyInvoiced: false,
    },

    urlVideoHelp1: config.CD_STG_BASE_URL + "/assets/videos/constitutivas_comisario.webm" + config.CD_STG_ACCESS_KEY,
  }),

  methods: {
    tryParseInt(value) {
      const result = parseInt(value, 10);
      return isNaN(result) ? null : result;
    },

    async getCatDocumentosPF() {
      try {
        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: "compareciente_pf",
        });
        value.forEach((element) => {
          const obj = { text: element.documento, value: element.id };
          this.optionsFisicas.push(obj);
        });
      } catch (error) {
        // this.loading = false;
      }
    },

    async getCatDocumentosPM() {
      try {
        const { value } = await CatDocumentosApi.list({
          page: 0,
          registersPerPage: 0,
          categoria: "compareciente_pm",
        });

        value.forEach((element) => {
          const obj = { text: element.documento, value: element.id };
          this.optionsMorales.push(obj);
        });
      } catch (error) {
        // this.loading = false;
      }
    },

    async getCatObjetosSociales() {
      const { value } = await CatObjetosSocialesApi.list();
      value.forEach((element) => {
        const obj = {
          text: element.objeto_social,
          value: element.objeto_social,
        };
        this.optionsObjetoSocial.push(obj);
      });
      const last = { text: "Otro", value: "Otro" };
      this.optionsObjetoSocial.push(last);
    },

    async getCorredurias() {
      try {
        const { value } = await FuncionesApi.getCorreduriasDomicilios({
          entidad: null,
          municipio: null,
        });

        this.catCorredurias = value.filter((c) => c.corredurias_id !== 17);
        this.catCorredurias.forEach((element) => {
          const exists = this.constitutiva.optionsEntidades.findIndex((x) => x.text === element.entidad);

          if (exists == -1) {
            const obj = {
              text: element.entidad,
              value: element.entidad,
            };
            this.constitutiva.optionsEntidades.push(obj);
          }
        });
      } catch {}
    },

    async getConstitucion() {
      this.loading = true;

      await this.getCorredurias();
      await this.getGastos();
      await this.getFacultades();

      try {
        const {
          tipo_societario,
          tiene_capital_variable,
          autoriza_cd_denominacion,
          objeto_social,
          objeto_actividad,
          capital_fijo,
          capital_variable,
          tipo_administracion,
          presidente_voto,
          firma_oficina,
          direccion_firma,
          fecha_firma,
          estatus,
          estatus_id,
          reglas_control,
          reglas_asambleas,
          capital_extranjero,
          clientes_id,
          denominaciones_sociales,
          accionistas,
          administradores,
          vigilancia,
          apoderados,
          corredurias_id,
          cotizacion,
          gastos,
          formularios,
          documentos,
          clausula_extranjeros,

          acciones_valor_nominal,
          exclusion_accionistas,
          domicilios,

          titulos_acciones,
          libros_corporativos,
          cotizaciones_id,

          beneficiario_pld,
          beneficiario_cff,
          link_calendario,

          entidad,
          delegacion_municipio,

          folio,
          nombre_beneficiario_pld,
          nombre_beneficiario_cff,
          referencia,
          id_cotizaciones_complementario,
          cotizacion_complementaria,
        } = await ConstitucionSociedadesApi.detail(this.constitutiva.id);

        this.constitutiva.tipo_societario = tipo_societario;
        this.constitutiva.formularios = formularios;
        this.constitutiva.folio = folio;
        this.constitutiva.nombre_beneficiario_pld = nombre_beneficiario_pld;
        this.constitutiva.nombre_beneficiario_cff = nombre_beneficiario_cff;
        this.constitutiva.referencia = referencia;
        this.constitutiva.cotizaciones_id = cotizaciones_id;
        this.constitutiva.cotizacion = cotizacion;
        this.constitutiva.id_cotizaciones_complementario = id_cotizaciones_complementario;
        this.constitutiva.cotizacion_complementaria = cotizacion_complementaria;
        this.constitutiva.estatus = estatus;
        this.constitutiva.estatus_id = estatus_id;
        this.datosFacturacion.cotizacionId = cotizaciones_id;

        for (let u = 0; u < formularios.length; u++) {
          if (formularios[u].guardado) {
            //guardado
            switch (formularios[u].formulario) {
              case "ComplementaInformacion":
                this.constitutiva.disabledComplementa = true;
                break;
              case "EntregaDocumentos":
                this.constitutiva.disabledDocumentos = true;
                break;
              case "CitaFirma":
                this.constitutiva.disabledCita = true;
                break;
              default:
                break;
            }
          }
        }

        this.validaEstatusForms();

        this.constitutiva.tiene_capital_variable = false;
        if (tiene_capital_variable === 1) {
          this.constitutiva.tiene_capital_variable = true;
        }
        this.constitutiva.autoriza_cd_denominacion = false;
        if (autoriza_cd_denominacion === 1) {
          this.constitutiva.autoriza_cd_denominacion = true;
        }

        this.constitutiva.titulos_acciones = false;
        if (titulos_acciones == 1) {
          this.constitutiva.titulos_acciones = true;
          let indexT = this.cat_gastos.findIndex((x) => x.clave === "titulos_acciones");
          this.constitutiva.subtotal_titulos = this.cat_gastos[indexT].costo;
        }
        this.constitutiva.libros_corporativos = false;
        if (libros_corporativos === 1) {
          this.constitutiva.libros_corporativos = true;
          let indexT = this.cat_gastos.findIndex((x) => x.clave === "libros_corporativos");
          this.constitutiva.subtotal_libros = this.cat_gastos[indexT].costo;
        }
        this.constitutiva.link_calendario = link_calendario;
        this.constitutiva.beneficiario_pld = beneficiario_pld;
        this.constitutiva.beneficiario_cff = beneficiario_cff;

        const objSocial = this.optionsObjetoSocial.find((x) => x.text === objeto_social);
        if (objSocial) {
          this.constitutiva.objeto_social = objeto_social;
        } else {
          this.constitutiva.objeto_social = "Otro";
          this.constitutiva.objeto_social_otro = objeto_social;
        }

        this.constitutiva.objeto_actividad = objeto_actividad;
        this.constitutiva.capital_fijo = capital_fijo;
        this.constitutiva.capital_variable = capital_variable;
        this.constitutiva.tipo_administracion = tipo_administracion;
        this.constitutiva.presidente_voto = false;
        if (presidente_voto === 1) {
          this.constitutiva.presidente_voto = true;
        }
        this.constitutiva.firma_oficina = false;
        if (firma_oficina === 1) {
          this.constitutiva.firma_oficina = true;
        }
        this.constitutiva.direccion_firma = direccion_firma;
        this.constitutiva.fecha_firma = fecha_firma;
        this.constitutiva.estatus = estatus;

        this.constitutiva.disabled = true;
        if (estatus === "Iniciado") {
          this.constitutiva.disabled = false;
        }
        // else if (
        //   estatus === "Pagado" ||
        //   estatus === "Documentos entregados" ||
        //   estatus === "Proceso interno" ||
        //   estatus === "Documento listo" ||
        //   estatus === "Terminado"
        // ) {
        // this.constitutiva.disabled = true;
        // }

        this.constitutiva.reglas_control = false;
        if (reglas_control === 1) {
          this.constitutiva.reglas_control = true;
        }
        this.constitutiva.reglas_asambleas = false;
        if (reglas_asambleas === 1) {
          this.constitutiva.reglas_asambleas = true;
        }
        this.constitutiva.capital_extranjero = false;
        if (capital_extranjero === 1) {
          this.constitutiva.capital_extranjero = true;
        }
        this.constitutiva.clientes_id = clientes_id;

        this.constitutiva.clausula_extranjeros = false;
        if (clausula_extranjeros === 1) {
          this.constitutiva.clausula_extranjeros = true;
        }

        // this.constitutiva.acciones_valor_nominal = false;
        // if (acciones_valor_nominal === 1) {
        //   this.constitutiva.acciones_valor_nominal = true;
        // }
        this.constitutiva.acciones_valor_nominal = acciones_valor_nominal;

        this.constitutiva.exclusion_accionistas = false;
        if (exclusion_accionistas === 1) {
          this.constitutiva.exclusion_accionistas = true;
        }

        this.constitutiva.pais = "México";
        if (domicilios.length > 0) {
          this.constitutiva.entidadDomicilio = domicilios[0].entidad;
          this.constitutiva.municipioDomicilio = domicilios[0].delegacion_municipio;
        }

        if (denominaciones_sociales.length > 0) {
          this.constitutiva.denominaciones_sociales_1 = denominaciones_sociales[0].denominacion_social;
          this.constitutiva.denominaciones_sociales_2 = denominaciones_sociales[1].denominacion_social;
          this.constitutiva.denominaciones_sociales_3 = denominaciones_sociales[2].denominacion_social;
          this.constitutiva.denominaciones_sociales = denominaciones_sociales;
        }

        for (let y = 0; y < accionistas.length; y++) {
          accionistas[y].constitucion_sociedades_id = this.constitutiva.id;
          if (accionistas[y].persona === "Física") {
            accionistas[y].persona = "Persona Física";
            accionistas[y].nombreCompleto = `${accionistas[y].nombre} ${accionistas[y].paterno} ${accionistas[y].materno}`;
          } else if (accionistas[y].persona === "Moral") {
            accionistas[y].persona = "Persona Moral";
            accionistas[y].nombreCompleto = `${accionistas[y].denominacion_social}`;
          }
          accionistas[y].porcentaje = accionistas[y].porcentaje_capital;
          // console.log(accionistas);
          accionistas[y].rfc = accionistas[y].rfc;
          accionistas[y].comparecientes_id = accionistas[y].comparecientes_id;

          for (let r = 0; r < accionistas[y].documentos.length; r++) {
            accionistas[y].documentos[r].nombreFile = accionistas[y].documentos[r].documento?.split("/").pop() || null;

            // let tipobd = accionistas[y].documentos[r].tipo;
            // if (
            //   tipobd === "Identificación oficial" ||
            //   tipobd === "Comprobante de domicilio" ||
            //   tipobd === "RFC o Cédula de identificación Fiscal" ||
            //   tipobd === "CURP" ||
            //   tipobd === "Constitutiva" ||
            //   tipobd === "Poderes del representante" ||
            //   tipobd === "Cuadro de distribución accionaria"
            //   // tipobd ===
            //   //   "PDF del formato de beneficiario controlador correspondiente a cada uno de las personas físicas finales, accionistas de la persona moral, que califiquen en tal carácter"
            // ) {
            //   accionistas[y].documentos[r].tipo = tipobd;
            // } else {
            //   accionistas[y].documentos[r].tipo = "Otro";
            //   accionistas[y].documentos[r].tipoOtro = tipobd;
            // }

            let tipo = this.optionsFisicas.find((x) => x.value == accionistas[y].documentos[r].cat_documentos_id);

            if (!tipo) {
              tipo = this.optionsMorales.find((x) => x.value == accionistas[y].documentos[r].cat_documentos_id);
            }

            accionistas[y].documentos[r].tipo = tipo?.text || "";
          }
        }

        this.constitutiva.accionistas = accionistas;
        this.constitutiva.administradores = administradores;
        this.constitutiva.vigilancia = vigilancia;

        for (let i = 0; i < apoderados.length; i++) {
          for (let k = 0; k < apoderados[i].facultades.length; k++) {
            let obj = this.cat_facultades.find((x) => x.id === apoderados[i].facultades[k].facultades_id);
            apoderados[i].facultades[k] = obj.facultad;
          }
        }

        this.constitutiva.apoderados = apoderados;
        this.constitutiva.corredurias_id = corredurias_id;
        this.constitutiva.selectedEntidad = entidad;
        this.constitutiva.selectedMunicipio = delegacion_municipio;
        this.constitutiva.selectedCorreduria = corredurias_id;

        if (cotizacion != null) {
          // this.constitutiva.cupones_id = cotizacion.cupones_id;
          // this.constitutiva.cupones_referencia_id =
          //   cotizacion.cupones_referencia_id;
          this.constitutiva.precio_total = cotizacion.precio_total;
          this.constitutiva.pagado = cotizacion.pagado;
          this.constitutiva.folio_transaccion = cotizacion.folio_transaccion;

          // this.constitutiva.titulos_acciones = false;
          // if (cotizacion.titulos_acciones === 1) {
          //   this.constitutiva.titulos_acciones = true;
          //   let indexT = this.cat_gastos.findIndex(
          //     x => x.clave === "titulos_acciones"
          //   );
          //   this.constitutiva.subtotal_titulos = this.cat_gastos[indexT].costo;
          // }
          // this.constitutiva.libros_corporativos = false;
          // if (cotizacion.libros_corporativos === 1) {
          //   this.constitutiva.libros_corporativos = true;
          //   let indexT = this.cat_gastos.findIndex(
          //     x => x.clave === "libros_corporativos"
          //   );
          //   this.constitutiva.subtotal_libros = this.cat_gastos[indexT].costo;
          // }
        }

        for (let r = 0; r < documentos.length; r++) {
          documentos[r].nombreFile = documentos[r].documento?.split("/").pop() || null;

          let tipobd = documentos[r].tipo;
          if (
            tipobd === "Identificación oficial" ||
            tipobd === "Comprobante de domicilio" ||
            tipobd === "RFC o Cédula de identificación Fiscal" ||
            tipobd === "CURP" ||
            tipobd === "Constitutiva de la persona moral" ||
            tipobd === "Poderes del representante" ||
            tipobd === "Cuadro de distribución accionaria"
            // tipobd ===
            //   "PDF del formato de beneficiario controlador correspondiente a cada uno de las personas físicas finales, accionistas de la persona moral, que califiquen en tal carácter"
          ) {
            documentos[r].tipo = tipobd;
          } else {
            documentos[r].tipo = "Otro";
            documentos[r].tipoOtro = tipobd;
          }
        }
        this.constitutiva.documentos = documentos;

        //si estan en consit.cat_gastos, están checked
        for (let r = 0; r < gastos.length; r++) {
          // console.log(this.cat_gastos);
          let obj_en_cat = this.cat_gastos.find((x) => x.id === gastos[r].cat_gastos_id);

          if (obj_en_cat) {
            let objGasto = this.constitutiva.gastos.find((x) => x.id === obj_en_cat.id);

            if (!objGasto) {
              const a = Object.assign({}, obj_en_cat);
              this.constitutiva.gastos.push(a);
            }
          }
        }

        //node cuando regresan de comparecientes
        const query = Object.assign({}, this.$route.query);
        if (query) {
          const node = query.node;
          if (node) {
            this.currentComponentBody = node;
          }
        }

        this.originalConstitutiva = JSON.parse(JSON.stringify(this.constitutiva));

        if (estatus_id == 6) {
          this.toShowExpediente = true;
        }
      } catch (error) {
        // await this.getConstitucion();
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    validaEstatusForms() {
      for (let i = 0; i < this.constitutiva.formularios.length; i++) {
        if (this.constitutiva.formularios[i].guardado) {
          //guardado
          switch (this.constitutiva.formularios[i].formulario) {
            case "DatosGenerales":
              this.constitutiva.validoGenerales = true;
              this.currentComponentBody = "DatosCapital";
              break;
            case "DatosCapital":
              this.constitutiva.validoCapital = true;
              this.currentComponentBody = "DatosOrganos";
              break;
            case "DatosOrganos":
              this.constitutiva.validoOrganos = true;
              this.currentComponentBody = "RepresentantesYApoderados";
              break;
            case "RepresentantesYApoderados":
              this.constitutiva.validoRepresentantes = true;
              this.currentComponentBody = "CapitulosEspeciales";
              break;
            case "CapitulosEspeciales":
              this.constitutiva.validoCapitulos = true;
              this.currentComponentBody = "EntidadFederativa";
              break;
            case "EntidadFederativa":
              this.constitutiva.validoEntidad = true;
              this.currentComponentBody = "Cotizacion";
              break;
            case "Cotizacion":
              this.constitutiva.validoCotizacion = true;
              this.currentComponentBody = "Accionistas";
              break;
            // case "ComplementaInformacion":
            //   this.constitutiva.validoComplementa = true;
            //   break;
            case "Accionistas":
              // this.constitutiva.validoAccionistas = true;
              this.currentComponentBody = "OrganosCorporativos";
              break;
            case "OrganosCorporativos":
              // this.constitutiva.validoOrganosCorporativos = true;
              this.currentComponentBody = "Apoderados";
              break;
            case "Apoderados":
              // this.constitutiva.validoApoderados = true;
              this.currentComponentBody = "BeneficiarioControlador";
              break;
            case "BeneficiarioControlador":
              // this.constitutiva.validoApoderados = true;
              this.constitutiva.disabledComplementa = true;
              this.currentComponentBody = "CitaFirma";
              break;
            case "CitaFirma":
              this.constitutiva.validoCita = true;
              break;
          }
        }
      }
    },

    async getFacultades() {
      try {
        // this.loading = true;
        const { value } = await CatFacultadesApi.list({
          page: 0,
          registersPerPage: 0,
        });
        this.cat_facultades = value;
        // this.loading = false;
      } catch (error) {
        // this.loading = false;
      }
    },

    async getGastos() {
      try {
        // this.loading = true;
        const { value } = await CatGastosApi.list({
          page: 0,
          registersPerPage: 0,
          cat_servicios_id: 1,
        });
        this.cat_gastos = value;
        // this.loading = false;
      } catch (error) {
        // this.loading = false;
      }
    },

    async saveConstitucion() {
      this.loading = true;

      const saved = await this.editConstitucion();

      if (saved && this.currentComponentBody === "Cotizacion") {
        try {
          const result = await FacturasApi.getFacturaByCotizacionId(this.constitutiva.cotizaciones_id);

          if (!result.facturaEncontrada) {
            this.$refs["confirmar-facturacion-modal"].show();

            this.loading = false;
            return;
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (saved && this.currentComponentBody === "BeneficiarioControlador" && this.constitutiva.estatus_id === 3) {
        this.currentComponentBody = "EsperaValidacion";
        this.loading = false;
        return;
      }
      if (saved) {
        const index = this.nodos.findIndex((o) => o === this.currentComponentBody);
        let node = "CitaFirma"; //a ver a donde envían después de completar esto

        if (index < this.nodos.length - 1) {
          node = this.nodos[index + 1];
        }

        await this.selected(node, true);
      }

      this.loading = false;
    },

    async editConstitucion() {
      this.loading = true;

      this.$refs["pago-modal"].hide();

      let capita_var = 0;
      if (this.constitutiva.tiene_capital_variable === true) {
        capita_var = 1;
      }
      let autoriza_cd = 0;
      if (this.constitutiva.autoriza_cd_denominacion === true) {
        autoriza_cd = 1;
      }
      let objeto_social = this.constitutiva.objeto_social;
      if (this.constitutiva.objeto_social === "Otro") {
        objeto_social = this.constitutiva.objeto_social_otro;
      }

      const keys_denominaciones_sociales = [
        "denominaciones_sociales_1",
        "denominaciones_sociales_2",
        "denominaciones_sociales_3",
      ];

      const denominaciones_sociales = keys_denominaciones_sociales.map((key) => ({
        denominacion_social: this.constitutiva[key],
      }));

      const accionistasA = [];

      for (let i = 0; i < this.constitutiva.accionistas.length; i++) {
        let persona = "Física";
        if (this.constitutiva.accionistas[i].persona === "Persona Moral") {
          persona = "Moral";
        }
        if (this.constitutiva.accionistas[i].id) {
          const obj = {
            comparecientes_id: this.constitutiva.accionistas[i].id,
            porcentaje_capital: this.constitutiva.accionistas[i].porcentaje,
            constitucion_sociedades_id: this.constitutiva.accionistas[i].constitucion_sociedades_id,
            cat_servicio_id: this.constitutiva.accionistas[i].cat_servicio_id,
            servicio_id: this.constitutiva.accionistas[i].servicio_id,
            // visible :1
          };
          accionistasA.push(obj);
        } else {
          const obj = {
            cliente_id: this.constitutiva.clientes_id,
            nombre: this.constitutiva.accionistas[i].nombre,
            paterno: this.constitutiva.accionistas[i].paterno,
            materno: this.constitutiva.accionistas[i].materno,
            persona: persona,
            denominacion_social: this.constitutiva.accionistas[i].denominacion_social,
            porcentaje_capital: this.constitutiva.accionistas[i].porcentaje,
            visible: this.constitutiva.accionistas[i].visible,
          };
          accionistasA.push(obj);
        }
      }

      let presidente_voto = 0;
      if (this.constitutiva.presidente_voto === true) {
        presidente_voto = 1;
      }

      let apoderados = [];
      let objA = {};
      for (let i = 0; i < this.constitutiva.apoderados.length; i++) {
        objA = {
          nombre: this.constitutiva.apoderados[i].nombre,
          paterno: this.constitutiva.apoderados[i].paterno,
          materno: this.constitutiva.apoderados[i].materno,
          rfc: this.constitutiva.apoderados[i].rfc,
        };
        objA.facultades = [];
        // if (this.constitutiva.apoderados[i].facultades) {
        for (let j = 0; j < this.constitutiva.apoderados[i].facultades.length; j++) {
          let index = this.cat_facultades.findIndex((o) => o.facultad === this.constitutiva.apoderados[i].facultades[j]);
          let objB = {};
          objB = { facultades_id: this.cat_facultades[index].id };
          objA.facultades.push(objB);
        }
        apoderados.push(objA);
        // }
      }

      let firma_oficina = 0;
      if (this.constitutiva.firma_oficina === true) {
        firma_oficina = 1;
      }

      let reglas_control = 0;
      if (this.constitutiva.reglas_control === true) {
        reglas_control = 1;
      }

      let reglas_asambleas = 0;
      if (this.constitutiva.reglas_asambleas === true) {
        reglas_asambleas = 1;
      }

      let capital_extranjero = 0;
      if (this.constitutiva.capital_extranjero === true) {
        capital_extranjero = 1;
      }

      const data = {
        clientes_id: this.constitutiva.clientes_id,
        activo: 1,
      };

      if (this.currentComponentBody === "DatosGenerales") {
        // data["estatus"] = "Iniciado";
        data["tipo_societario"] = this.constitutiva.tipo_societario;
        data["tiene_capital_variable"] = capita_var;
        data["autoriza_cd_denominacion"] = autoriza_cd;
        data["objeto_social"] = objeto_social;
        data["objeto_actividad"] = this.constitutiva.objeto_actividad;
        data["denominaciones_sociales"] = denominaciones_sociales;
        data["formularios"] = [{ formulario: "DatosGenerales", estatus: 1, guardado: 1 }];
      }
      if (this.currentComponentBody === "DatosCapital") {
        // data["estatus"] = "Iniciado";
        data["capital_fijo"] = this.constitutiva.capital_fijo;
        data["capital_variable"] = this.constitutiva.capital_variable;
        data["accionistas"] = accionistasA;
        data["capital_extranjero"] = capital_extranjero;
        data["formularios"] = [
          { formulario: "DatosOrganos", estatus: 1 },
          { formulario: "DatosCapital", estatus: 1, guardado: 1 },
        ];
      }
      if (this.currentComponentBody === "DatosOrganos") {
        // data["estatus"] = "Iniciado";
        data["tipo_administracion"] = this.constitutiva.tipo_administracion;
        data["presidente_voto"] = presidente_voto;
        data["administradores"] = this.constitutiva.administradores;
        data["vigilancia"] = this.constitutiva.vigilancia;
        data["formularios"] = [
          { formulario: "RepresentantesYApoderados", estatus: 1 },
          { formulario: "DatosOrganos", estatus: 1, guardado: 1 },
        ];
      }
      if (this.currentComponentBody === "RepresentantesYApoderados") {
        // data["estatus"] = "Iniciado";
        data["apoderados"] = apoderados;
        data["beneficiario_pld"] = this.constitutiva.beneficiario_pld;
        data["beneficiario_cff"] = this.constitutiva.beneficiario_cff;
        data["formularios"] = [
          { formulario: "CapitulosEspeciales", estatus: 1 },
          { formulario: "RepresentantesYApoderados", estatus: 1, guardado: 1 },
        ];
        data.nombre_beneficiario_pld = this.constitutiva.nombre_beneficiario_pld;
        data.nombre_beneficiario_cff = this.constitutiva.nombre_beneficiario_cff;
      }
      if (this.currentComponentBody === "CapitulosEspeciales") {
        // data["estatus"] = "Iniciado";
        data["reglas_control"] = reglas_control;
        data["reglas_asambleas"] = reglas_asambleas;
        data["formularios"] = [
          { formulario: "EntidadFederativa", estatus: 1 },
          { formulario: "CapitulosEspeciales", estatus: 1, guardado: 1 },
        ];

        let exclusion_accionistas = 0;
        if (this.constitutiva.exclusion_accionistas === true) {
          exclusion_accionistas = 1;
        }
        data["exclusion_accionistas"] = exclusion_accionistas;
      }
      if (this.currentComponentBody === "EntidadFederativa") {
        // data["corredurias_id"] = this.constitutiva.corredurias_id;
        data["firma_oficina"] = firma_oficina;
        data["entidad"] = this.constitutiva.selectedEntidad;
        data["delegacion_municipio"] = this.constitutiva.selectedMunicipio;
        data["formularios"] = [
          { formulario: "Cotizacion", estatus: 1 },
          { formulario: "EntidadFederativa", estatus: 1, guardado: 1 },
        ];

        const domicilios = [];
        const domicilio = {
          pais: this.constitutiva.pais,
          entidad: this.constitutiva.entidadDomicilio,
          delegacion_municipio: this.constitutiva.municipioDomicilio,
        };
        domicilios.push(domicilio);
        data["domicilios"] = domicilios;
      }
      if (this.currentComponentBody === "Cotizacion") {
        data["estatus_id"] = "2"; //cuando este pagado entra aqui
        this.constitutiva.disabled = true;

        let titulos_acciones = 0;
        if (this.constitutiva.titulos_acciones === true) {
          titulos_acciones = 1;
        }
        data["titulos_acciones"] = titulos_acciones;
        let libros_corporativos = 0;
        if (this.constitutiva.libros_corporativos === true) {
          libros_corporativos = 1;
        }
        data["libros_corporativos"] = libros_corporativos;

        this.constitutiva.pagado = 1;
        data["cotizacion"] = this.constitutiva.cotizacion;

        let gastos = [];
        for (let j = 0; j < this.constitutiva.gastos.length; j++) {
          let objGastos = {
            cat_gastos_id: this.constitutiva.gastos[j].id,
            costo: this.constitutiva.gastos[j].costo,
          };
          gastos.push(objGastos);
        }
        data["gastos"] = gastos;
        data["formularios"] = [
          // { formulario: "ComplementaInformacion", estatus: 1 },
          { formulario: "Cotizacion", estatus: 1, guardado: 1 },
          { formulario: "Accionistas", estatus: 1 },
        ];
      }

      // if (this.currentComponentBody === "ComplementaInformacion") {
      //   data["estatus_id"] = "3";
      //   data["administradores"] = this.constitutiva.administradores;
      //   data["vigilancia"] = this.constitutiva.vigilancia;
      //   data["apoderados"] = apoderados;
      //   data["formularios"] = [
      //     // { formulario: "EntregaDocumentos", estatus: 1 },
      //     { formulario: "FirmaDigital", estatus: 1 },
      //     { formulario: "ComplementaInformacion", estatus: 1, guardado: 1 },
      //   ];
      //   let clausula_extranjeros = 0;
      //   if (this.constitutiva.clausula_extranjeros === true) {
      //     clausula_extranjeros = 1;
      //   }
      //   data["clausula_extranjeros"] = clausula_extranjeros;

      //   let acciones_valor_nominal = 0;
      //   if (this.constitutiva.acciones_valor_nominal === true) {
      //     acciones_valor_nominal = 1;
      //   }
      //   data["acciones_valor_nominal"] = acciones_valor_nominal;
      // }
      if (this.currentComponentBody === "Accionistas") {
        data["formularios"] = [
          { formulario: "Accionistas", estatus: 1, guardado: 1 },
          { formulario: "OrganosCorporativos", estatus: 1 },
        ];
        let clausula_extranjeros = 0;
        if (this.constitutiva.clausula_extranjeros === true) {
          clausula_extranjeros = 1;
        }
        data["clausula_extranjeros"] = clausula_extranjeros;

        // let acciones_valor_nominal = 0;
        // if (this.constitutiva.acciones_valor_nominal === true) {
        //   acciones_valor_nominal = 1;
        // }
        // data["acciones_valor_nominal"] = acciones_valor_nominal;
        data["acciones_valor_nominal"] = this.constitutiva.acciones_valor_nominal;
      }
      if (this.currentComponentBody === "OrganosCorporativos") {
        data["administradores"] = this.constitutiva.administradores;
        data["vigilancia"] = this.constitutiva.vigilancia;
        data["formularios"] = [
          { formulario: "OrganosCorporativos", estatus: 1, guardado: 1 },
          { formulario: "Apoderados", estatus: 1 },
        ];
        // let clausula_extranjeros = 0;
        // if (this.constitutiva.clausula_extranjeros === true) {
        //   clausula_extranjeros = 1;
        // }
        // data["clausula_extranjeros"] = clausula_extranjeros;

        // let acciones_valor_nominal = 0;
        // if (this.constitutiva.acciones_valor_nominal === true) {
        //   acciones_valor_nominal = 1;
        // }
        // data["acciones_valor_nominal"] = acciones_valor_nominal;
      }
      if (this.currentComponentBody === "Apoderados") {
        data["apoderados"] = apoderados;
        data["formularios"] = [
          { formulario: "Apoderados", estatus: 1, guardado: 1 },
          { formulario: "BeneficiarioControlador", estatus: 1 },
        ];
      }
      if (this.currentComponentBody === "BeneficiarioControlador") {
        data["estatus_id"] = 3;
        data["formularios"] = [
          { formulario: "BeneficiarioControlador", estatus: 1, guardado: 1 },
          // { formulario: "CitaFirma", estatus: 1 },
        ];
      }
      if (this.currentComponentBody === "EntregaDocumentos") {
        data["estatus_id"] = "3"; //??

        var documentos = JSON.parse(JSON.stringify(this.constitutiva.documentos));
        // for (let u = 0; u < documentos.length; u++) {
        //   if (documentos[u].tipo === "Otro") {
        //     documentos[u].tipo = documentos[u].tipoOtro;
        //   }
        // }
        data["documentos"] = documentos;
        data["documentos"] = documentos;
        data["formularios"] = [
          { formulario: "CitaFirma", estatus: 1 },
          { formulario: "EntregaDocumentos", estatus: 1, guardado: 1 },
        ];
      }
      if (this.currentComponentBody === "CitaFirma") {
        data["direccion_firma"] = this.constitutiva.direccion_firma;
        data["fecha_firma"] = this.constitutiva.fecha_firma;
        data["formularios"] = [
          { formulario: "DocListo", estatus: 1 },
          { formulario: "CitaFirma", estatus: 1, guardado: 1 },
        ];
      }

      try {
        if (this.currentComponentBody != "Cotizacion") {
          // Trae la cotizacion
          const _cotizacion = await CotizacionesApi.detail(this.constitutiva.cotizaciones_id);
          data.cotizacion = _cotizacion;
        }

        const { accionistas, formularios, estatus_id } = await ConstitucionSociedadesApi.edit(this.constitutiva.id, data);

        if (accionistas != null && accionistas.length) {
          for (let i = 0; i < accionistas.length; i++) {
            this.constitutiva.accionistas[i] = {
              ...this.constitutiva.accionistas[i],
              ...accionistas[i],
              comparecientes_id: accionistas[i].id,
            };
            // let newId = accionistas[i].id;
            // this.constitutiva.accionistas[i].id = newId;
            // const a = Object.assign({}, this.constitutiva.accionistas[i]);
            // this.constitutiva.accionistas.splice([i], 1, a);
          }
          // this.constitutiva.accionistas = accionistas;
        }

        this.constitutiva.formularios = formularios;
        this.constitutiva.estatus_id = estatus_id;

        if (this.currentComponentBody === "DatosGenerales") {
          this.constitutiva.validoGenerales = true;
        }
        if (this.currentComponentBody === "DatosCapital") {
          this.constitutiva.validoCapital = true;
        }
        if (this.currentComponentBody === "DatosOrganos") {
          this.constitutiva.validoOrganos = true;
        }
        if (this.currentComponentBody === "RepresentantesYApoderados") {
          this.constitutiva.validoRepresentantes = true;
        }
        if (this.currentComponentBody === "CapitulosEspeciales") {
          this.constitutiva.validoCapitulos = true;
        }
        if (this.currentComponentBody === "EntidadFederativa") {
          this.constitutiva.validoEntidad = true;
        }
        if (this.currentComponentBody === "Cotizacion") {
          this.constitutiva.validoCotizacion = true;
        }
        if (this.currentComponentBody === "ComplementaInformacion") {
          this.constitutiva.disabledComplementa = true;
          this.constitutiva.validoComplementa = true;
        }
        if (this.currentComponentBody === "Accionistas") {
          // this.constitutiva.disabledComplementa = true;
          this.constitutiva.validoAccionistas = true;
        }
        if (this.currentComponentBody === "OrganosCorporativos") {
          // this.constitutiva.disabledComplementa = true;
          this.constitutiva.validoOrganosCorporativos = true;
        }
        if (this.currentComponentBody === "Apoderados") {
          // this.constitutiva.disabledComplementa = true;
          this.constitutiva.validoApoderados = true;
        }
        if (this.currentComponentBody === "BeneficiarioControlador") {
          this.constitutiva.disabledComplementa = true;
          this.constitutiva.validoBeneficiarioControlador = true;
        }
        if (this.currentComponentBody === "EntregaDocumentos") {
          this.constitutiva.disabledEntrega = true;
          this.constitutiva.validoEntrega = true;
        }
        if (this.currentComponentBody === "CitaFirma") {
          this.constitutiva.disabledCita = true;
          this.constitutiva.constitutiva.validoCita = true;
        }

        this.$toast.success("Información guardada", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return true;
      } catch (error) {
        console.log(error);

        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
        return false;
      }
    },

    async pagar() {
      try {
        this.loading = true;

        const data = {
          clientes_id: this.constitutiva.clientes_id,
          referencia: this.constitutiva.referencia
        };
        data.cotizacion = await CotizacionesApi.edit(this.constitutiva.cotizaciones_id, this.constitutiva.cotizacion);

        await ConstitucionSociedadesApi.edit(this.constitutiva.id, data);
        this.$refs["pago-modal"].show();
      } catch (error) {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async payCotizacion(payed) {
      if (payed == true) {
        this.saveConstitucion();
      }
    },

    async payCotizacionSpei(payed) {
      if (payed == true) {
        this.constitutiva.disabled = true;
        this.$refs["pago-modal"].hide();
        this.$toast.warning("Recibirá la información para la transferencia en su correo electrónico", {
          timeout: 10000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } else {
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.loading = false;
      }
    },

    async beforeLeave(answer) {
      if (answer) {
        this.next();
      }
    },

    setCambios() {
      // this.constitutiva.cambios = [];
      //no importa meterlos a cambios porque al final no los mando
      //en la peticion y no se guardan
      if (this.currentComponentBody === "DatosGenerales") {
        if (this.constitutiva.tipo_societario != this.originalConstitutiva.tipo_societario) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "tipo_societario",
            valor_original: this.originalConstitutiva.tipo_societario,
            valor_cambio: this.constitutiva.tipo_societario,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.tipo_societario = this.constitutiva.tipo_societario;
        }
        if (this.constitutiva.tiene_capital_variable != this.originalConstitutiva.tiene_capital_variable) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "tiene_capital_variable",
            valor_original: this.originalConstitutiva.tiene_capital_variable,
            valor_cambio: this.constitutiva.tiene_capital_variable,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.tiene_capital_variable = this.constitutiva.tiene_capital_variable;
        }
        if (this.constitutiva.autoriza_cd_denominacion != this.originalConstitutiva.autoriza_cd_denominacion) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "autoriza_cd_denominacion",
            valor_original: this.originalConstitutiva.autoriza_cd_denominacion,
            valor_cambio: this.constitutiva.autoriza_cd_denominacion,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.autoriza_cd_denominacion = this.constitutiva.autoriza_cd_denominacion;
        }
        if (this.constitutiva.objeto_social != this.originalConstitutiva.objeto_social) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "objeto_social",
            valor_original: this.originalConstitutiva.objeto_social,
            valor_cambio: this.constitutiva.objeto_social,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.objeto_social = this.constitutiva.objeto_social;
        }
        if (this.constitutiva.objeto_social_otro != this.originalConstitutiva.objeto_social_otro) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "objeto_social_otro",
            valor_original: this.originalConstitutiva.objeto_social_otro,
            valor_cambio: this.constitutiva.objeto_social_otro,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.objeto_social_otro = this.constitutiva.objeto_social_otro;
        }
        if (this.constitutiva.objeto_actividad != this.originalConstitutiva.objeto_actividad) {
          let obj = {
            formulario: "DatosGenerales",
            campo: "objeto_actividad",
            valor_original: this.originalConstitutiva.objeto_actividad,
            valor_cambio: this.constitutiva.objeto_actividad,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.objeto_actividad = this.constitutiva.objeto_actividad;
        }
        if (this.originalConstitutiva.denominaciones_sociales) {
          if (
            this.constitutiva.denominaciones_sociales_1 !=
            this.originalConstitutiva.denominaciones_sociales[0].denominacion_social
          ) {
            let obj = {
              formulario: "DatosGenerales",
              campo: "denominaciones_sociales_1",
              valor_original: this.originalConstitutiva.denominaciones_sociales[0].denominacion_social,
              valor_cambio: this.constitutiva.denominaciones_sociales_1,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.denominaciones_sociales[0].denominacion_social =
              this.constitutiva.denominaciones_sociales_1;
          }
          if (
            this.constitutiva.denominaciones_sociales_2 !=
            this.originalConstitutiva.denominaciones_sociales[1].denominacion_social
          ) {
            let obj = {
              formulario: "DatosGenerales",
              campo: "denominaciones_sociales_2",
              valor_original: this.originalConstitutiva.denominaciones_sociales[1].denominacion_social,
              valor_cambio: this.constitutiva.denominaciones_sociales_2,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.denominaciones_sociales[1].denominacion_social =
              this.constitutiva.denominaciones_sociales_2;
          }
          if (
            this.constitutiva.denominaciones_sociales_3 !=
            this.originalConstitutiva.denominaciones_sociales[2].denominacion_social
          ) {
            let obj = {
              formulario: "DatosGenerales",
              campo: "denominaciones_sociales_3",
              valor_original: this.originalConstitutiva.denominaciones_sociales[2].denominacion_social,
              valor_cambio: this.constitutiva.denominaciones_sociales_3,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.denominaciones_sociales[2].denominacion_social =
              this.constitutiva.denominaciones_sociales_3;
          }
        }
      }

      if (this.currentComponentBody === "DatosCapital") {
        //accionistas no veo cambios o sí???
        if (this.constitutiva.capital_fijo != this.originalConstitutiva.capital_fijo) {
          let obj = {
            formulario: "DatosCapital",
            campo: "capital_fijo",
            valor_original: this.originalConstitutiva.capital_fijo,
            valor_cambio: this.constitutiva.capital_fijo,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.capital_fijo = this.constitutiva.capital_fijo;
        }
        if (this.constitutiva.capital_variable != this.originalConstitutiva.capital_variable) {
          let obj = {
            formulario: "DatosCapital",
            campo: "capital_variable",
            valor_original: this.originalConstitutiva.capital_variable,
            valor_cambio: this.constitutiva.capital_variable,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.capital_variable = this.constitutiva.capital_variable;
        }
        if (this.constitutiva.capital_extranjero != this.originalConstitutiva.capital_extranjero) {
          let obj = {
            formulario: "DatosCapital",
            campo: "capital_extranjero",
            valor_original: this.originalConstitutiva.capital_extranjero,
            valor_cambio: this.constitutiva.capital_extranjero,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.capital_extranjero = this.constitutiva.capital_extranjero;
        }
      }

      if (this.currentComponentBody === "DatosOrganos") {
        // data["vigilancia"] = this.constitutiva.vigilancia;
        if (this.constitutiva.tipo_administracion != this.originalConstitutiva.tipo_administracion) {
          let obj = {
            formulario: "DatosOrganos",
            campo: "tipo_administracion",
            valor_original: this.originalConstitutiva.tipo_administracion,
            valor_cambio: this.constitutiva.tipo_administracion,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.tipo_administracion = this.constitutiva.tipo_administracion;
        }

        if (this.constitutiva.presidente_voto != this.originalConstitutiva.presidente_voto) {
          let obj = {
            formulario: "DatosOrganos",
            campo: "presidente_voto",
            valor_original: this.originalConstitutiva.presidente_voto,
            valor_cambio: this.constitutiva.presidente_voto,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.presidente_voto = this.constitutiva.presidente_voto;
        }

        try {
          for (let i = 0; i < this.constitutiva.administradores.length; i++) {
            const objKeys = Object.keys(this.constitutiva.administradores[i]);
            objKeys.forEach((key) => {
              if (this.constitutiva.administradores[i][key] != this.originalConstitutiva.administradores[i][key]) {
                let obj = {
                  formulario: "DatosOrganos",
                  campo: `admin_${i}_${[key]}`,
                  valor_original: this.originalConstitutiva.administradores[i][key],
                  valor_cambio: this.constitutiva.administradores[i][key],
                };
                this.constitutiva.cambios.push(obj);
                this.originalConstitutiva.administradores[i][key] = this.constitutiva.administradores[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          for (let i = 0; i < this.constitutiva.vigilancia.length; i++) {
            const objKeys = Object.keys(this.constitutiva.vigilancia[i]);
            objKeys.forEach((key) => {
              if (this.constitutiva.vigilancia[i][key] != this.originalConstitutiva.vigilancia[i][key]) {
                let obj = {
                  formulario: "DatosOrganos",
                  campo: `admin_${i}_${[key]}`,
                  valor_original: this.originalConstitutiva.vigilancia[i][key],
                  valor_cambio: this.constitutiva.vigilancia[i][key],
                };
                this.constitutiva.cambios.push(obj);
                this.originalConstitutiva.vigilancia[i][key] = this.constitutiva.vigilancia[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }
      }

      if (this.currentComponentBody === "RepresentantesYApoderados") {
        try {
          // for (let i = 0; i < this.constitutiva.apoderados.length; i++) {
          //   const objKeys = Object.keys(this.constitutiva.apoderados[i]);
          //     for (let r = 0; r < objKeys.length; r++) {

          //       if (objKeys[r] === "facultades") {
          //         console.log("entro a facultades");
          //         // for (
          //         //   let u = 0;
          //         //   u < this.constitutiva.apoderados[i].facultades.length;
          //         //   u++
          //         // ) {
          //         // console.log(this.constitutiva.apoderados[i].facultades);
          //         //   console.log(
          //         //     this.originalConstitutiva.apoderados[i].facultades[u]
          //         //   );
          //         //   if (
          //         //     this.constitutiva.apoderados[i].facultades[u] !=
          //         //     this.originalConstitutiva.apoderados[i].facultades[u]
          //         //   ) {
          //         //     let obj = {
          //         //       formulario: "DatosOrganos",
          //         //       campo: `apoderado_${i}_${key}_${u}`,
          //         //       valor_original: this.originalConstitutiva.apoderados[i]
          //         //         .facultades[u],
          //         //       valor_cambio: this.constitutiva.apoderados[i].facultades[
          //         //         u
          //         //       ]
          //         //     };
          //         //     console.log(obj);
          //         //     this.constitutiva.cambios.push(obj);
          //         //     this.originalConstitutiva.apoderados[i].facultades[
          //         //       u
          //         //     ] = this.constitutiva.apoderados[i].facultades[u];
          //         //   }
          //         //  }
          //         // }

          //       } else if (objKeys[r] != "facultades") {
          //         if (
          //           apoderados[i][key] !=
          //           this.originalConstitutiva.apoderados[i][key]
          //         ) {
          //           let obj = {
          //             formulario: "DatosOrganos",
          //             campo: `admin_${i}_${[key]}`,
          //             valor_original: this.originalConstitutiva.apoderados[i][
          //               key
          //             ],
          //             valor_cambio: apoderados[i][key]
          //           };
          //           this.constitutiva.cambios.push(obj);

          //           this.originalConstitutiva.apoderados[i][key] =
          //             apoderados[i][key];
          //         }
          //       }
          //     }
          //   }
          for (let i = 0; i < this.constitutiva.apoderados.length; i++) {
            if (this.constitutiva.apoderados[i].nombre != this.originalConstitutiva.apoderados[i].nombre) {
              let obj = {
                formulario: "RepresentantesYApoderados",
                campo: "apoderados_nombre_" + i,
                valor_original: this.originalConstitutiva.apoderados[i].nombre,
                valor_cambio: this.constitutiva.apoderados[i].nombre,
              };
              this.constitutiva.cambios.push(obj);
              this.originalConstitutiva.apoderados[i].nombre = this.constitutiva.apoderados[i].nombre;
            }

            if (this.constitutiva.apoderados[i].paterno != this.originalConstitutiva.apoderados[i].paterno) {
              let obj = {
                formulario: "RepresentantesYApoderados",
                campo: "apoderados_paterno_" + i,
                valor_original: this.originalConstitutiva.apoderados[i].paterno,
                valor_cambio: this.constitutiva.apoderados[i].paterno,
              };
              this.constitutiva.cambios.push(obj);
              this.originalConstitutiva.apoderados[i].paterno = this.constitutiva.apoderados[i].paterno;
            }

            if (this.constitutiva.apoderados[i].materno != this.originalConstitutiva.apoderados[i].materno) {
              let obj = {
                formulario: "RepresentantesYApoderados",
                campo: "apoderados_materno_" + i,
                valor_original: this.originalConstitutiva.apoderados[i].materno,
                valor_cambio: this.constitutiva.apoderados[i].materno,
              };
              this.constitutiva.cambios.push(obj);
              this.originalConstitutiva.apoderados[i].materno = this.constitutiva.apoderados[i].materno;
            }

            // if (
            //   this.constitutiva.apoderados[i].rfc !=
            //   this.originalConstitutiva.apoderados[i].rfc
            // ) {
            //   let obj = {
            //     formulario: "RepresentantesYApoderados",
            //     campo: "apoderados_rfc_" + i,
            //     valor_original: this.originalConstitutiva.apoderados[i].rfc,
            //     valor_cambio: this.constitutiva.apoderados[i].rfc
            //   };
            //   this.constitutiva.cambios.push(obj);
            //   this.originalConstitutiva.apoderados[
            //     i
            //   ].rfc = this.constitutiva.apoderados[i].rfc;
            // }

            for (let r = 0; r < this.constitutiva.apoderados[i].facultades.length; r++) {
              if (this.constitutiva.apoderados[i].facultades[r] != this.originalConstitutiva.apoderados[i].facultades[r]) {
                let obj = {
                  formulario: "RepresentantesYApoderados",
                  campo: "apoderados_" + i + "_facultades_" + r,
                  valor_original: this.originalConstitutiva.apoderados[i].facultades[r],
                  valor_cambio: this.constitutiva.apoderados[i].facultades[r],
                };
                this.constitutiva.cambios.push(obj);
                this.originalConstitutiva.apoderados[i].facultades[r] = this.constitutiva.apoderados[i].facultades[r];
              }
            }
          }
        } catch (e) {
          // console.log(e);
        }
      }

      if (this.currentComponentBody === "CapitulosEspeciales") {
        if (this.constitutiva.reglas_control != this.originalConstitutiva.reglas_control) {
          let obj = {
            formulario: "CapitulosEspeciales",
            campo: "reglas_control",
            valor_original: this.originalConstitutiva.reglas_control,
            valor_cambio: this.constitutiva.reglas_control,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.reglas_control = this.constitutiva.reglas_control;
        }
        if (this.constitutiva.reglas_asambleas != this.originalConstitutiva.reglas_asambleas) {
          let obj = {
            formulario: "CapitulosEspeciales",
            campo: "reglas_asambleas",
            valor_original: this.originalConstitutiva.reglas_asambleas,
            valor_cambio: this.constitutiva.reglas_asambleas,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.reglas_asambleas = this.constitutiva.reglas_asambleas;
        }
      }

      if (this.currentComponentBody === "EntidadFederativa") {
        if (this.constitutiva.firma_oficina != this.originalConstitutiva.firma_oficina) {
          let obj = {
            formulario: "EntidadFederativa",
            campo: "firma_oficina",
            valor_original: this.originalConstitutiva.firma_oficina,
            valor_cambio: this.constitutiva.firma_oficina,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.firma_oficina = this.constitutiva.firma_oficina;
        }

        if (this.constitutiva.selectedEntidad != this.originalConstitutiva.selectedEntidad) {
          let obj = {
            formulario: "EntidadFederativa",
            campo: "selectedEntidad",
            valor_original: this.originalConstitutiva.selectedEntidad,
            valor_cambio: this.constitutiva.selectedEntidad,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.selectedEntidad = this.constitutiva.selectedEntidad;
        }

        if (this.constitutiva.selectedMunicipio != this.originalConstitutiva.selectedMunicipio) {
          let obj = {
            formulario: "EntidadFederativa",
            campo: "selectedMunicipio",
            valor_original: this.originalConstitutiva.selectedMunicipio,
            valor_cambio: this.constitutiva.selectedMunicipio,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.selectedMunicipio = this.constitutiva.selectedMunicipio;
        }

        //   if (
        //     this.constitutiva.selectedCorredor !=
        //     this.originalConstitutiva.selectedCorredor
        //   ) {
        //     let obj = {
        //       formulario: "EntidadFederativa",
        //       campo: "selectedCorredor",
        //       valor_original: this.originalConstitutiva.selectedCorredor,
        //       valor_cambio: this.constitutiva.selectedCorredor
        //     };
        //     this.constitutiva.cambios.push(obj);
        //     this.originalConstitutiva.selectedCorredor = this.constitutiva.selectedCorredor;
        //   }
      }

      if (this.currentComponentBody === "Cotizacion") {
        if (this.constitutiva.titulos_acciones != this.originalConstitutiva.titulos_acciones) {
          const obj = {
            formulario: "Cotizacion",
            campo: "titulos_acciones",
            valor_original: this.originalConstitutiva.titulos_acciones,
            valor_cambio: this.constitutiva.titulos_acciones,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.titulos_acciones = this.constitutiva.titulos_acciones;
        }
        if (this.constitutiva.libros_corporativos != this.originalConstitutiva.libros_corporativos) {
          let obj = {
            formulario: "Cotizacion",
            campo: "libros_corporativos",
            valor_original: this.originalConstitutiva.libros_corporativos,
            valor_cambio: this.constitutiva.libros_corporativos,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.libros_corporativos = this.constitutiva.libros_corporativos;
        }

        // for (let j = 0; j < this.constitutiva.gastos.length; j++) {
        //   let objGastos = {
        //     cat_gastos_id: this.constitutiva.gastos[j].id,
        //     costo: this.constitutiva.gastos[j].costo
        //   };
        //   gastos.push(objGastos);
        // }
        // data["gastos"] = gastos;
        for (let i = 1; i < this.constitutiva.gastos.length; i++) {
          if (this.constitutiva.gastos[i].servicio != this.originalConstitutiva.gastos[i].servicio) {
            let obj = {
              formulario: "Cotizacion",
              campo: "gastos_servicio_" + i,
              valor_original: this.originalConstitutiva.gastos[i].servicio,
              valor_cambio: this.constitutiva.gastos[i].servicio,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.gastos[i].servicio = this.constitutiva.gastos[i].servicio;
          }
        }
      }

      if (this.currentComponentBody === "ComplementaInformacion") {
        if (this.constitutiva.clausula_extranjeros != this.originalConstitutiva.clausula_extranjeros) {
          let obj = {
            formulario: "ComplementaInformacion",
            campo: "clausula_extranjeros",
            valor_original: this.originalConstitutiva.clausula_extranjeros,
            valor_cambio: this.constitutiva.clausula_extranjeros,
          };
          this.constitutiva.cambios.push(obj);
          this.originalConstitutiva.clausula_extranjeros = this.constitutiva.clausula_extranjeros;
        }

        try {
          for (let i = 0; i < this.constitutiva.administradores.length; i++) {
            const objKeys = Object.keys(this.constitutiva.administradores[i]);
            objKeys.forEach((key) => {
              if (this.constitutiva.administradores[i][key] != this.originalConstitutiva.administradores[i][key]) {
                let obj = {
                  formulario: "DatosOrganos",
                  campo: `admin_${i}_${[key]}`,
                  valor_original: this.originalConstitutiva.administradores[i][key],
                  valor_cambio: this.constitutiva.administradores[i][key],
                };
                this.constitutiva.cambios.push(obj);
                this.originalConstitutiva.administradores[i][key] = this.constitutiva.administradores[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          for (let i = 0; i < this.constitutiva.vigilancia.length; i++) {
            const objKeys = Object.keys(this.constitutiva.vigilancia[i]);
            objKeys.forEach((key) => {
              if (this.constitutiva.vigilancia[i][key] != this.originalConstitutiva.vigilancia[i][key]) {
                let obj = {
                  formulario: "DatosOrganos",
                  campo: `admin_${i}_${[key]}`,
                  valor_original: this.originalConstitutiva.vigilancia[i][key],
                  valor_cambio: this.constitutiva.vigilancia[i][key],
                };
                this.constitutiva.cambios.push(obj);
                this.originalConstitutiva.vigilancia[i][key] = this.constitutiva.vigilancia[i][key];
              }
            });
          }
        } catch (e) {
          // console.log(e);
        }

        for (let i = 0; i < this.constitutiva.apoderados.length; i++) {
          if (this.constitutiva.apoderados[i].nombre != this.originalConstitutiva.apoderados[i].nombre) {
            let obj = {
              formulario: "RepresentantesYApoderados",
              campo: "apoderados_nombre_" + i,
              valor_original: this.originalConstitutiva.apoderados[i].nombre,
              valor_cambio: this.constitutiva.apoderados[i].nombre,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.apoderados[i].nombre = this.constitutiva.apoderados[i].nombre;
          }

          if (this.constitutiva.apoderados[i].paterno != this.originalConstitutiva.apoderados[i].paterno) {
            let obj = {
              formulario: "RepresentantesYApoderados",
              campo: "apoderados_paterno_" + i,
              valor_original: this.originalConstitutiva.apoderados[i].paterno,
              valor_cambio: this.constitutiva.apoderados[i].paterno,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.apoderados[i].paterno = this.constitutiva.apoderados[i].paterno;
          }

          if (this.constitutiva.apoderados[i].materno != this.originalConstitutiva.apoderados[i].materno) {
            let obj = {
              formulario: "RepresentantesYApoderados",
              campo: "apoderados_materno_" + i,
              valor_original: this.originalConstitutiva.apoderados[i].materno,
              valor_cambio: this.constitutiva.apoderados[i].materno,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.apoderados[i].materno = this.constitutiva.apoderados[i].materno;
          }

          if (this.constitutiva.apoderados[i].rfc != this.originalConstitutiva.apoderados[i].rfc) {
            let obj = {
              formulario: "RepresentantesYApoderados",
              campo: "apoderados_rfc_" + i,
              valor_original: this.originalConstitutiva.apoderados[i].rfc,
              valor_cambio: this.constitutiva.apoderados[i].rfc,
            };
            this.constitutiva.cambios.push(obj);
            this.originalConstitutiva.apoderados[i].rfc = this.constitutiva.apoderados[i].rfc;
          }

          for (let r = 0; r < this.constitutiva.apoderados[i].facultades.length; r++) {
            if (this.constitutiva.apoderados[i].facultades[r] != this.originalConstitutiva.apoderados[i].facultades[r]) {
              let obj = {
                formulario: "RepresentantesYApoderados",
                campo: "apoderados_" + i + "_facultades_" + r,
                valor_original: this.originalConstitutiva.apoderados[i].facultades[r],
                valor_cambio: this.constitutiva.apoderados[i].facultades[r],
              };
              this.constitutiva.cambios.push(obj);
              this.originalConstitutiva.apoderados[i].facultades[r] = this.constitutiva.apoderados[i].facultades[r];
            }
          }
        }
      }
    },

    async changeCurrentComponentBody() {
      const index = this.nodos.findIndex((o) => o === this.currentComponentBody);
      let node = "CitaFirma"; //a ver a donde envían después de completar esto

      if (index < this.nodos.length - 1) {
        node = this.nodos[index + 1];
      }

      await this.selected(node, true);
    },

    async selected(node, automatic) {
      this.loading = true;

      this.currentInnerComponentBody = "BeneficiarioControlador";

      // let estatus = 1; //esto se borra y descomenta lo siguiente
      let constitutiva_id = 0;
      if (this.constitutiva.id) {
        constitutiva_id = this.constitutiva.id;
      }

      let estatus = "";
      if (node === "go") {
        estatus = await this.getEstatusForm(this.prenode, constitutiva_id);
      } else {
        estatus = await this.getEstatusForm(node, constitutiva_id);
      }

      if (estatus === 0) {
        if (this.constitutiva.estatus_id == 3) {
          this.$toast.info("Pronto te haremos llegar información al respecto.", {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });
          this.loading = false;
          return;
        }
        this.$toast.warning("Complete el formulario actual para poder continuar", {
          timeout: 6000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } else {
        if (automatic === true) {
          this.currentComponentBody = node;
          if (
            node === "DatosGenerales" ||
            node === "DatosCapital" ||
            node === "DatosOrganos" ||
            node === "RepresentantesYApoderados" ||
            node === "CapitulosEspeciales" ||
            node === "EntidadFederativa"
          ) {
            this.currentComponentInfoHead = "InfoBase";
          } else {
            this.currentComponentInfoHead = null;
          }

          if (
            node === "CitaFirma" ||
            node === "DocListo" ||
            node === "InfoBase" ||
            node === "Cotizacion" ||
            node === "EntregaDocumentos" ||
            node === "ComplementaInformacion" ||
            node === "Accionistas" ||
            node === "BeneficiarioControlador" ||
            node === "OrganosCorporativos" ||
            node === "Apoderados" ||
            node === "FirmaDigital"
          ) {
            this.currentComponentInfoHead = null;
          }
        } else {
          if (node != "go") {
            this.prenode = node;
          }

          this.setCambios();

          if (this.constitutiva.cambios.length > 0) {
            if (node === "go") {
              this.constitutiva.cambios = [];
              this.$refs["modal-confirm-dialog"].hide();
              node = this.prenode;
              this.currentComponentBody = node;

              this.currentComponentBody = node;
              if (
                node === "DatosGenerales" ||
                node === "DatosCapital" ||
                node === "DatosOrganos" ||
                node === "RepresentantesYApoderados" ||
                node === "CapitulosEspeciales" ||
                node === "EntidadFederativa"
              ) {
                this.currentComponentInfoHead = "InfoBase";
              }

              if (
                node === "CitaFirma" ||
                node === "DocListo" ||
                node === "InfoBase" ||
                node === "Cotizacion" ||
                node === "EntregaDocumentos" ||
                node === "ComplementaInformacion" ||
                node === "Accionistas" ||
                node === "BeneficiarioControlador" ||
                node === "OrganosCorporativos" ||
                node === "Apoderados" ||
                node === "FirmaDigital"
              ) {
                this.currentComponentInfoHead = null;
              }
            } else {
              this.$refs["modal-confirm-dialog"].show();
            }
          } else {
            this.currentComponentBody = node;
            if (
              node === "DatosGenerales" ||
              node === "DatosCapital" ||
              node === "DatosOrganos" ||
              node === "RepresentantesYApoderados" ||
              node === "CapitulosEspeciales" ||
              node === "EntidadFederativa"
            ) {
              this.currentComponentInfoHead = "InfoBase";
            }

            if (
              node === "CitaFirma" ||
              node === "DocListo" ||
              node === "InfoBase" ||
              node === "Cotizacion" ||
              node === "EntregaDocumentos" ||
              node === "ComplementaInformacion" ||
              node === "Accionistas" ||
              node === "BeneficiarioControlador" ||
              node === "OrganosCorporativos" ||
              node === "Apoderados" ||
              node === "FirmaDigital"
            ) {
              this.currentComponentInfoHead = null;
            }
          }
        }
      }

      this.loading = false;
    },

    async getEstatusForm(formulario, consitucion_sociedades_id) {
      try {
        return await CatFormulariosConstitucionSociedadesApi.getEstatusForm(formulario, consitucion_sociedades_id);
      } catch {
        return 0;
      }
    },

    confirmGenerarFactura(crearFactura) {
      this.$refs["confirmar-facturacion-modal"].hide();

      if (!crearFactura) {
        const index = this.nodos.findIndex((o) => o === this.currentComponentBody);
        let node = "CitaFirma"; //a ver a donde envían después de completar esto

        if (index < this.nodos.length - 1) {
          node = this.nodos[index + 1];
        }

        this.selected(node, true);

        return;
      }

      this.$refs["datos-fiscales-modal"].show();
    },

    closedFacturacion() {
      const index = this.nodos.findIndex((o) => o === this.currentComponentBody);
      let node = "CitaFirma"; //a ver a donde envían después de completar esto

      if (index < this.nodos.length - 1) {
        node = this.nodos[index + 1];
      }

      this.selected(node, true);

      this.$refs["datos-fiscales-modal"].hide();
    },

    canceledFacturacion() {
      const index = this.nodos.findIndex((o) => o === this.currentComponentBody);
      let node = "CitaFirma"; //a ver a donde envían después de completar esto

      if (index < this.nodos.length - 1) {
        node = this.nodos[index + 1];
      }

      this.selected(node, true);

      this.$refs["datos-fiscales-modal"].hide();
    },

    editBeneficiarioHandler(index) {
      this.currentAccionistaBeneficiario = this.constitutiva.accionistas[index];
      this.currentInnerComponentBody = "DeclaracionesBeneficiarioControlador";
    },

    changeInnerComponentHandler(action) {
      if (this.currentInnerComponentBody === "DeclaracionesBeneficiarioControlador") {
        this.currentInnerComponentBody = "BeneficiarioControlador";
      } else if (this.currentInnerComponentBody === "BeneficiarioControlador") {
        this.currentInnerComponentBody = "DeclaracionesBeneficiarioControlador";
      } else {
        this.currentInnerComponentBody = "BeneficiarioControlador";
      }
    },
  },
};
</script>

<style scoped>
#titulo {
  text-align: center;
  color: #e87b31;
}
</style>
